import React, { useContext, useEffect, useState } from 'react';
import { Activity } from '@bingads-webui-react/hoc-with-signal';
import { PermissionsContext } from '@bingads-webui-react/hoc-with-permissions';
import { DisplayAdsWithCopilot } from '@bingads-webui-campaign-react/xandr-display-ads-campaign-shared-components';
import { ServerContext } from '@bingads-webui-campaign-react/server-context';
import { isCopilotRegionRestricted } from '@bingads-webui-react/copilot-utils';
import { DisplayAds as DisplayAdsWithoutCopilot } from './display-ads';

export const DisplayAds = (props) => {
  const permissions = useContext(PermissionsContext);
  const serverContext = useContext(ServerContext);

  const [isCopilotEnabled, setIsCopilotEnabled] = useState(false);
  useEffect(() => {
    // check if copilot is restricted in this region
    isCopilotRegionRestricted({
      feature: 'Recommendations',
      permissions,
      serverContext,
    }).then(isRegionRestricted => setIsCopilotEnabled(!isRegionRestricted));
  }, [permissions, serverContext]);

  if (permissions.dynamic.DisplayPlusCopilotAssetGeneration && isCopilotEnabled) {
    return <Activity name="DisplayAdsCopilotSettings"> <DisplayAdsWithCopilot {...props} /> </Activity>;
  }

  return <Activity name="DisplayAdsSettings"> <DisplayAdsWithoutCopilot {...props} /> </Activity>;
};

export { useDisplayAdsRepository } from './use-display-ads-repository';

